/**
 * Canonical payment-status display helpers. One source of truth so TicketDisplay,
 * UserDashboard (My Passes), and AttendeeList render the same copy.
 *
 * A cash RSVP is NOT paid until the host manually confirms at the door. We must
 * not label it "Paid" anywhere guest-facing or host-facing.
 */

export function isCashRsvp(ticket) {
  if (!ticket) return false;
  return ticket.payment_mode === 'cash' || ticket.rsvp_status === 'rsvp';
}

export function isCashCollected(ticket) {
  return isCashRsvp(ticket) && ticket?.payment_confirmed === true;
}

export function isComp(ticket) {
  return !!ticket?.is_comp;
}

/**
 * Short badge label for lists/tables ("Paid", "Due at Door", "Comp", etc.).
 * Used in AttendeeList and UserDashboard.
 */
export function paymentBadgeLabel(ticket) {
  if (!ticket) return '';
  if (isComp(ticket)) return 'Comp';
  if (isCashRsvp(ticket)) return isCashCollected(ticket) ? 'Cash Collected' : 'Due at Door';
  if (ticket.status === 'revoked') return 'Revoked';
  if (ticket.amount_paid > 0) return 'Paid';
  return 'Paid'; // $0 paid events still count as paid transactions
}

/**
 * Long label for the Ticket Display "Total" section.
 */
export function paymentTotalLabel(ticket) {
  if (!ticket) return 'Total';
  if (isComp(ticket)) return 'Complimentary';
  if (isCashCollected(ticket)) return 'Cash Collected';
  if (isCashRsvp(ticket)) return 'Payment Due at Door';
  return 'Total Paid';
}
